module.exports = __webpack_public_path__ + "static/fipcpinkblossom1-4f9618d1f9bf91152a11c6e013d6ebad.jpeg";